import React from "react";
import { Link } from "react-router-dom";
import classes from "./product.module.css";
import { useProduct } from "../../../Pregrine/CartPage/ProductListing/useProduct";
import Quantity from "./Quantity";
import { FaRupeeSign } from "react-icons/fa";
import ProductOption from "../../ProductOption/ProductOption";
import classNames from "classnames";
import { Trash2 as DeleteIcon } from "react-feather";
import { formatIndianNumber } from "../../../utility/formatPrice";

const Product = (props) => {
  const { item, setIsCartUpdating } = props;

  const talonProps = useProduct({ item, setIsCartUpdating });

  const {
    handleRemoveFromCart,
    handleUpdateItemQuantity,
    product,
    updateError,
    removeItemError,
  } = talonProps;

  const {
    image,
    name,
    options,
    quantity,
    stockStatus,
    urlKey,
    PriceDetails,
    sku,
  } = product;

  const { discountPrice, regularPrice, savedPrice } = PriceDetails;

  const itemLink = `/product/${urlKey}.html`;

  const stockStatusMessage =
    stockStatus === "OUT_OF_STOCK" ? <span>Out-of-stock</span> : "";

  return (
    <>
      <div className="col-lg-12">
        <span className={classes.errorText}>
          {updateError && updateError.message
            ? updateError.message
            : removeItemError && removeItemError.message
            ? removeItemError.message
            : null}
        </span>

        <ul className={`${classes.cartitemmain} list-unstyled`}>
          <div className={`${classes.cartitemlist}`}>
            <li>
              <div className={classes.cartimg}>
                <Link to={itemLink}>
                  <img
                    src={
                      item.__typename === "ConfigurableCartItem"
                        ? item?.configured_variant?.thumbnail?.url
                        : image
                    }
                    alt={name}
                  />
                </Link>
              </div>
            </li>
            <li className={classes.productName}>
              <h6 className="font-weight-bold">Item Description</h6>
              <Link to={itemLink}>
                <h6>
                  <b>{name}</b>
                </h6>
              </Link>

              <p className={classes.sku}>
                <span>Sku : </span>
                <span>
                  {item.__typename.toLowerCase() === "configurablecartitem"
                    ? item.configured_variant.sku
                    : sku}
                </span>
              </p>

              {savedPrice && (
                <p className={`ps-2 mb-0 pb-2 ${classes.priceparagh}`}>
                  You saved:
                  <span className={classes.savedPrice}>
                    <FaRupeeSign />
                    <span>{savedPrice.amount_off}</span>
                  </span>
                </p>
              )}
            </li>

            <span className={classes.stockStatusMessage}>
              {stockStatusMessage}
            </span>
            <Quantity
              itemId={item.id}
              initialValue={quantity}
              onChange={handleUpdateItemQuantity}
            />
            <li className="text-end">
              <h6 className="d-flex justify-content-center font-weight-bold">
                Price
              </h6>
              <h4
                className={classNames(classes.priceContainer, "ps-2 mb-0 pb-2")}
              >
                {discountPrice ? (
                  <>
                    <FaRupeeSign />
                    <span>{formatIndianNumber(discountPrice.value)}</span>
                  </>
                ) : (
                  <>
                    <span>MRP</span>
                    <FaRupeeSign />
                    <span>{formatIndianNumber(regularPrice.value)}</span>
                  </>
                )}
              </h4>
              {discountPrice && (
                <h6 className="ps-2 mb-0 pb-2">
                  <span className={classes.regPrice}>
                    <span>MRP</span>
                    <span
                      className={classNames(classes.delPrice, "text-muted")}
                    >
                      <FaRupeeSign />
                      <span>{formatIndianNumber(regularPrice.value)}</span>
                    </span>
                  </span>
                </h6>
              )}

              {/* <p
              
              style={{ cursor: "pointer" }}
              className="ps-2 mb-0 pb-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12Z"
                ></path>
              </svg>
            </p> */}
              <button className={classes.delBtn} onClick={handleRemoveFromCart}>
                <DeleteIcon size={22} className={classes.delIcon} />
              </button>
            </li>
          </div>
          <ProductOption options={options} parentSku={sku || ""} />
          {item.__typename === "BundleCartItem" && item?.bundle_options ? (
            <ul className={classes.bundleChildList}>
              {item?.bundle_options[0].values.map((item) => (
                <li className={classes.bundleChildItem}>{item.label}</li>
              ))}
            </ul>
          ) : null}
          {item?.product?.stock_status !== "IN_STOCK" ? (
            <span style={{ color: "red" }}>
              This item is currently out-of-stock and must be removed in order
              to Checkout.
            </span>
          ) : null}
        </ul>
      </div>
    </>
  );
};

export default Product;
